// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"ea3428f9","318":"c8b26ad6","377":"139dd227","409":"1c04f1b0","590":"fc7b3a6b","639":"c6d20a14","848":"e293e6a7","914":"4679d40a","926":"3640dde6","996":"f3c71cc1"}[chunkId] + ".chunk.js";
};